import Typography from "@mui/material/Typography";

const Address = ({ address, title }) => {
	if (!address) {
		return null;
	}
	return (
		<div>
			<Typography color="address-title" className="font-bold">
				{title}
			</Typography>
			<Typography color="text-14 font-medium">{`${address.firstName} ${address.lastName}`}</Typography>
			<Typography color="textSecondary">
				{address.addressLine1} {address.addressLine2} {address.city}
			</Typography>
			<Typography color="textSecondary">
				{address.state?.name} {address.zipCode}
			</Typography>
		</div>
	);
};

export default Address;
